import { TableColumnsType } from 'antd';
import { DeviceSensorModel } from 'core/domain/devices/models';
import TooltipAtom from 'components/atoms/TooltipAtom';
import SwitchAtom from 'components/atoms/SwitchAtom';
import './styles.scss';

export interface ExpandedPeripheralDevicesTranslations {
  nameText: string;
  roomText: string;
  usageText: string;
  typeText: string;
  notReportedText: string;
  showInAppText: string;
  showInAppDisabledTooltipText: string;
}

export interface ExpandedPeripheralDevicesColumnsOptionsModel {
  translations: ExpandedPeripheralDevicesTranslations;
  getIsSensorVisibilityToggleDisabled: (sensorUuid: string) => boolean;
  getIsVisibilityToggleLoading: (deviceOrSensorUuid: string) => boolean;
  onToggleSensorVisibility: (checked: boolean, sensorUuid: string) => void;
}

interface Props {
  options: ExpandedPeripheralDevicesColumnsOptionsModel;
}

export const ExpandedPeripheralDevicesColumns = ({ options }: Props): TableColumnsType<DeviceSensorModel> => {
  const {
    onToggleSensorVisibility,
    getIsVisibilityToggleLoading,
    getIsSensorVisibilityToggleDisabled,
    translations: {
      nameText,
      notReportedText,
      roomText,
      typeText,
      usageText,
      showInAppText,
      showInAppDisabledTooltipText,
    }
  } = options;

  return [
    {
      title: 'Id',
      key: 'sensorId',
      dataIndex: 'sensorId',
    },
    {
      title: nameText,
      key: 'name',
      render: (text, { name }) => !!name ? <span>{name}</span> : <span className={'ExpandedPeripheralDevicesColumns__notReported'}>{notReportedText}</span>
    },
    {
      title: roomText,
      key: 'room',
      render: (text, { room }) => !!room ? <span>{room}</span> : <span className={'ExpandedPeripheralDevicesColumns__notReported'}>{notReportedText}</span>
    },
    {
      title: usageText,
      key: 'usage',
      render: (text, { usage }) => !!usage ? <span>{usage}</span> : <span className={'ExpandedPeripheralDevicesColumns__notReported'}>{notReportedText}</span>
    },
    {
      title: typeText,
      key: 'sensorType',
      render: (text, { sensorType }) => !!sensorType ? <span>{sensorType}</span> : <span className={'ExpandedPeripheralDevicesColumns__notReported'}>{notReportedText}</span>
    },
    {
      title: showInAppText,
      key: 'visible',
      width: '10%',
      render: (text, { visible, accessSensorId }) => {
        return (
          <TooltipAtom
            title={getIsSensorVisibilityToggleDisabled(accessSensorId)
              ? showInAppDisabledTooltipText
              : null
            }
          >
            <SwitchAtom
              checked={visible}
              loading={getIsVisibilityToggleLoading(accessSensorId)}
              disabled={getIsSensorVisibilityToggleDisabled(accessSensorId)}
              onChange={(checked) => onToggleSensorVisibility(checked, accessSensorId)}
            />
          </TooltipAtom>
        )
      },
    },
  ];
}
